import PhotoCardItem from './PhotoCardItem';

const PhotoCardList = ({
  data,
  baseUrl,
  checkedArray,
  uncheckedArray,
  checkBoxHandler,
  isAproovePhoto,
}) => (
  <>
    {data.map((item) => {
      return (
        <PhotoCardItem
          key={item.id}
          src={`${baseUrl}${item.src}`}
          reason={!isAproovePhoto && item.reason}
          checked={checkedArray.includes(item)}
          checkBoxHandler={(event) => {
            checkBoxHandler(event, item, uncheckedArray, isAproovePhoto);
          }}
        />
      );
    })}
  </>
);

export default PhotoCardList;
